import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import TopBar from "@/components/TopBar";
import api from "@/api/client";
import MenuEditor from "@/components/MenuEditor";
import { Store, ArrowRight } from "lucide-react";

export default function AdminMenu() {
  const [sp] = useSearchParams();
  const restaurantId = sp.get("restaurant") || "";
  const [restaurant, setRestaurant] = useState(null);

  useEffect(() => {
    if (!restaurantId) return;
    (async () => {
      try {
        const { data } = await api.get(`/restaurants/${restaurantId}`);
        setRestaurant(data);
      } catch { setRestaurant(null); }
    })();
  }, [restaurantId]);

  return (
    <div className="min-h-screen bg-[var(--background)]">
      <TopBar/>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <Link to="/admin/restaurants" className="inline-flex items-center gap-1 text-sm text-[var(--text-secondary)] hover:text-primary-brand font-bold mb-4" data-testid="back-to-restaurants">
          <ArrowRight size={14}/> العودة للمطاعم
        </Link>

        {restaurant && (
          <div className="mb-4 text-xs text-[var(--text-secondary)] flex items-center gap-2">
            <Store size={11} className="text-primary-brand"/>
            <span>تقوم بتعديل قائمة: <span className="font-bold text-primary-brand">{restaurant.name}</span></span>
          </div>
        )}

        {!restaurantId && (
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded-2xl text-sm mb-4">
            💡 تظهر أصناف جميع المطاعم. اذهب إلى <Link to="/admin/restaurants" className="font-bold underline">إدارة المطاعم</Link> واختر مطعماً للتعديل عليه.
          </div>
        )}

        <MenuEditor scope="admin" restaurantId={restaurantId}/>
      </div>
    </div>
  );
}
